export default (settings: any) => settings['theming'] * (1 / 60) * 10
